var insertvideos = [];
var insertlives = [];
var insertimgs = [];
var insertpicturesets = [];
var insertaudios = [];
var insertFiles = [];

var allcolumns = [];
var columninfo = [];

function replacevideo(body) {
    var patt = new RegExp("<!--VIDEO#[0-9]+,[0-9]+,[0-9]+-->", "gim");
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var videoinfo = substr.match(/\d+/g);
            var id = videoinfo[0];
            var width = videoinfo[1];
            var height = videoinfo[2];
            if (width == 0) {
                width = "100%";
            } else {
                width = width + "px";
            }
            if (height == 0) {
                height = "100%";
            } else {
                height = height + "px";
            }

            var newhtml =
                '<div id="video_' +
                id +
                '" class="content-video" data-src="' +
                id +
                '" ';
            newhtml +=
                'style="width: ' +
                width +
                "; height: " +
                height +
                '; max-width: 100%;" />';
            var newpatt = new RegExp(substr, "gim");
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replaceaudio(body) {
    var patt = new RegExp("<!--AUDIO#[0-9]+,[0-9]+,[0-9]+-->", "gim");
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var audioinfo = substr.match(/\d+/g);
            var id = audioinfo[0];
            var width = audioinfo[1];
            var height = audioinfo[2];
            if (width == 0) {
                width = "100%";
            } else {
                width = width + "px";
            }
            if (height == 0) {
                height = "100%";
            } else {
                height = height + "px";
            }

            var newhtml =
                '<div id="audio_' +
                id +
                '" class="content-audio" data-src="' +
                id +
                '" ';
            newhtml +=
                'style="width: ' +
                width +
                "; height: " +
                height +
                '; max-width: 100%;" />';
            var newpatt = new RegExp(substr, "gim");
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replacelive(body) {
    var patt = new RegExp("<!--LIVE#[0-9]+,[0-9]+,[0-9]+-->", "gim");
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var videoinfo = substr.match(/\d+/g);
            var id = videoinfo[0];
            var width = videoinfo[1];
            var height = videoinfo[2];
            if (width == 0) {
                width = "100%";
            } else {
                width = width + "px";
            }
            if (height == 0) {
                height = "100%";
            } else {
                height = height + "px";
            }

            var newhtml =
                '<div id="live_' +
                id +
                '" class="content-live" data-src="' +
                id +
                '" ';
            newhtml +=
                'style = "width: ' +
                width +
                "; height: " +
                height +
                '; max-width: 100%;" />';
            var newpatt = new RegExp(substr, "gim");
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replaceimg(body) {
    var patt = new RegExp("<!--PICTURE#[0-9]+,[0-9]+,[0-9]+-->", "gim");
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var videoinfo = substr.match(/\d+/g);
            var id = videoinfo[0];
            var width = videoinfo[1];
            var height = videoinfo[2];

            var imginfo = getimginfobyid(id);

            if (!imginfo) continue;
            if (width == 0) width = imginfo.width;
            if (height == 0) height = imginfo.height;
            var url = imginfo.url + "?w=" + width + "&s=1";
            var newhtml = '<img src="' + url + '" title="" ';
            // newhtml += 'style="width: ' + width + 'px;max-width: 100%;" />';
            newhtml += 'style=" ' + 'max-width: 100%;" />';
            var newpatt = new RegExp(substr, "gim");
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replacepictureset(body) {
    var patt = new RegExp("<!--PICTURESET#[0-9]+-->", "gim");
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var substrs = result;
        for (var i = 0; i < substrs.length; i++) {
            var substr = substrs[i];
            var videoinfo = substr.match(/\d+/g);
            var id = videoinfo[0];

            var info = getpicturesetinfobyid(id);

            var newhtml = "";
            // for (var i = 0; i < info.pictures.length; i++) {
            //     var url = info.pictures[i].url + '?w=' + info.pictures[i].width + '&s=1';
            //     var width = info.pictures[i].width;
            //     if (width && !isNaN(parseInt(width)) && parseInt(width) > 0) {
            //         width = 'width: ' + info.pictures[i].width + 'px;';
            //     } else {
            //         width = '';
            //     }
            //     newhtml += '<img src="' + url + '" style="' + width + 'max-width: 100%;" />';
            // }
            if (info.pictures.length == 1) {
                newhtml +=
                    '<img src="' + info.pictures[0].url + '?w=668&h=0&s=1" />';
            } else if (info.pictures.length > 1) {
                newhtml += '<div class="big-img"><img /></div>';
                newhtml += '<div class="nav-imgs"><ul>\n';
                for (var j = 0; j < info.pictures.length; j++) {
                    var obj = info.pictures[j];
                    newhtml +=
                        '<li class="nav-img"><img src="' +
                        obj.url +
                        '?w=54&h=54&s=3" /></li>\n';
                }
                newhtml += "</ul></div>\n";
            }

            var newpatt = new RegExp(substr, "gim");
            body = body.replace(newpatt, newhtml);
        }
    }

    return body;
}

function replaceImagePlaceholder(body) {
    var patt = new RegExp("--ds-image-([0-9]+)--", "gim");
    var seen = {};
    var cssVars = [];
    var result = null;
    while ((result = patt.exec(body)) != null) {
        var id = result[1];
        if (seen[id]) continue;
        seen[id] = true;
        var imginfo = getimginfobyid(id);
        if (!imginfo) continue;
        var url = imginfo.url + "?w=" + (imginfo.width || 0) + "&s=1";
        cssVars.push("--ds-image-" + id + "--: url('" + url + "');");
    }
    if (cssVars.length > 0) {
        var styleTag = "<style>.ds-image-placeholder { " + cssVars.join(" ") + " }</style>";
        body = styleTag + body;
    }
    return body;
}

function replaceFiles(body) {
    var patt = new RegExp(
        /<!--FILE#[0-9]+;?([A-Za-z0-9\u4e00-\u9fa5^%&',;=?$\x22-]*(\.?)[A-Za-z0-9]+),ending-->/,
        "gim"
    );

    var result = body.match(patt);
    if (result !== null) {
        var substrs = result;

        for (var i = 0; i < substrs.length; i++) {
            var substrId = substrs[i].match(/[0-9]+/g)[0];
            var substr = substrs[i];

            var info = getFileInfo(parseInt(substrId));
            var html = "";
            if (info) {
                var name = info.name.substr(0, info.name.lastIndexOf("."));
                html =
                    '<a class="file-attachment" href="' +
                    info.url +
                    "?d=" +
                    name +
                    '" download="' +
                    name +
                    '">' +
                    info.name +
                    "</a>";
            }

            var newpatt = new RegExp(substr, "gim");
            body = body.replace(newpatt, html);
        }
    }

    return body;
}
function getFileInfo(id) {
    for (var i = 0; i < insertFiles.length; i++) {
        if (id === insertFiles[i].id) return insertFiles[i];
    }
}
function getimginfobyid(id) {
    for (var i = 0; i < insertimgs.length; i++) {
        if (id == insertimgs[i].id) {
            return insertimgs[i];
        }
    }

    return null;
}

function getliveinfo(id) {
    for (var i = 0; i < insertlives.length; i++) {
        if (id == insertlives[i].id) {
            return insertlives[i];
        }
    }

    return null;
}

function getpicturesetinfobyid(id) {
    for (var i = 0; i < insertpicturesets.length; i++) {
        if (id == insertpicturesets[i].id) {
            return insertpicturesets[i];
        }
    }

    return null;
}

function getvideoinfo(id) {
    for (var i = 0; i < insertvideos.length; i++) {
        if (id == insertvideos[i].id) {
            return insertvideos[i];
        }
    }

    return null;
}

function getaudioinfo(id) {
    for (var i = 0; i < insertaudios.length; i++) {
        if (id == insertaudios[i].id) {
            return insertaudios[i];
        }
    }

    return null;
}

module.exports = {
    setcontentinfo: function (extension) {
        if (extension.videos) {
            var ids = "";
            for (var i = 0; i < extension.videos.length; i++) {
                ids += extension.videos[i] + ",";
                if (i == extension.videos.length - 1)
                    ids = ids.substr(0, ids.length - 1);
            }
            insertvideos = getVideos(ids);
        }

        if (extension.audios) {
            var ids = "";
            for (var i = 0; i < extension.audios.length; i++) {
                ids += extension.audios[i] + ",";
                if (i == extension.audios.length - 1)
                    ids = ids.substr(0, ids.length - 1);
            }
            insertaudios = getAudios(ids);
        }

        if (extension.lives) {
            var ids = "";
            for (var i = 0; i < extension.lives.length; i++) {
                ids += extension.lives[i] + ",";
                if (i == extension.lives.length - 1)
                    ids = ids.substr(0, ids.length - 1);
            }
            insertlives = getLives(ids);
        }

        if (extension.pictures) {
            var ids = "";
            for (var i = 0; i < extension.pictures.length; i++) {
                ids += extension.pictures[i] + ",";
                if (i == extension.pictures.length - 1)
                    ids = ids.substr(0, ids.length - 1);
            }
            insertimgs = getPictures(ids);
        }

        if (extension.picturesets) {
            var ids = "";
            for (var i = 0; i < extension.picturesets.length; i++) {
                ids += extension.picturesets[i] + ",";
                if (i == extension.picturesets.length - 1)
                    ids = ids.substr(0, ids.length - 1);
            }
            insertpicturesets = getPicturesets(ids);
        }

        if (extension.audios) {
            for (var i = 0; i < extension.audios.length; i++) {
                insertaudios.push(extension.audios[i]);
            }
        }
        var files = extension.files || [];
        if (files.length > 0) {
            if (typeof files[0] === "object") {
                insertFiles = files;
            } else {
                var ids = files.join();
                insertFiles = getFiles(ids);
                // console.log(insertFiles);
            }
        }
    },

    geteditorbody: function (body) {
        body = replacevideo(body);
        body = replaceaudio(body);
        body = replacelive(body);
        body = replaceimg(body);
        body = replacepictureset(body);
        body = replaceImagePlaceholder(body);
        body = replaceFiles(body);
        return body;
    },

    playlive: function (id) {
        var lives = getliveinfo(id);
        if (!lives) return null;
        var urls = [];
        urls.push(lives.rtmpUrl);
        urls.push(lives.flvUrl);
        urls.push(lives.m3u8Url);

        return urls;
    },

    playvideo: function (id) {
        var videos = getvideoinfo(id);
        if (!videos || !videos.versions) return null;
        var urls = [];
        for (var j = 0; j < videos.versions.length; j++) {
            urls.push(videos.versions[j].url);
        }

        return urls;
    },

    playaudio: function (id) {
        var audios = getaudioinfo(id);
        if (audios == null || !audios) return null;
        if (audios.versions && audios.versions.length > 0) {
            var obj = {
                nAppWidth: 500,
                strTitle: audios.title,
                strAudioUrl: audios.versions[0].url,
                blNeedUI: true,
            };
            return obj;
        }

        return null;
    },
};
